module.exports = __webpack_public_path__ + "Roboto-Thin.7500519de3d82e33d158.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.woff
// module id = 311
// module chunks = 2